import axios from 'axios';

/**
 * Public site API client.
 * Points to the new Express backend at REACT_APP_API_URL.
 * All calls use bare paths like /site, /page/home, /settings.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1',
  timeout: 15000,
  withCredentials: true,
});

export default api;
